<template>
  <b-field>
    <b-select v-model="currencyInput" :disabled="!editable" expanded>
      <option v-for="currency in currencyList" :key="currency.code" :value="currency.code">
        {{ currency.name }}
        <span v-if="platform">{{ " x" + currency.exchangeRate }}</span>
      </option>
    </b-select>

    <p class="control">
      <b-button class="is-static">
        {{ currencySymbol }}
      </b-button>
    </p>
  </b-field>
</template>

<script>
export default {
  name: "CurrencyPicker",
  props: {
    value: {
      type: String,
      default: "EUR",
    },
    editable: {
      type: Boolean,
      default: true,
    },
    platform: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currencyInput: this.value || "EUR",
      currencyCodes: [
        "AUD",
        "BRL",
        "CAD",
        "CNY",
        "DKK",
        "EUR",
        "HKD",
        "INR",
        "ILS",
        "JPY",
        "NOK",
        "GBP",
        "RUB",
        "SEK",
        "CHF",
        "USD",
      ],
      exchangeRates: {
        EUR: 1.0,
        USD: 1.11,
        JPY: 133.0,
        CNY: 7.1,
        GBP: 0.85,
        SAR: 5.0,
        AED: 4.5,
        ARS: 100.0,
        BRL: 5.8,
        DKK: 7.45,
        HKD: 8.6,
        INR: 85.0,
        ILS: 3.7,
        KWD: 0.4,
        CHF: 1.05,
        SEK: 10.88,
        RUB: 120.0,
        NOK: 10.2,
        CAD: 1.45,
        AUD: 1.6,
      },
    };
  },
  computed: {
    currencySymbol() {
      try {
        if (this.value == "JPY") {
          return "¥";
        }
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: this.value,
        })
          .format(0)
          .substring(5);
      } catch (_error) {
        return "";
      }
    },
    currencyList() {
      // combines codes with translated names
      let names = this.$t("currencyNames");
      let currencyList = this.currencyCodes.map((y) => {
        return {
          name: names[y],
          code: y,
          exchangeRate: this.exchangeRates[y],
        };
      });
      return currencyList;
    },
  },
  watch: {
    value() {
      if (this.value != this.currencyInput) {
        this.currencyInput = this.value;
      }
    },
    currencyInput() {
      this.$emit("input", this.currencyInput);
    },
  },
};
</script>

<style></style>
